//React
import { useState, useEffect, useRef } from 'react';

//Mui
import { Container, Typography, Box, TextField, CssBaseline, Button, Paper, FormControl, InputLabel, Input, InputAdornment, IconButton, Checkbox, Grid } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

//Router 
import { useNavigate } from 'react-router-dom';

import theme from '../../data/theme';
import { HeaderLogin, Copyright } from './components/BasePublic';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { decryptCryptoJs, encryptCryptoJs } from '../../Helper/crypto';
import { apiLogin } from '../../api/auth/apiLogin';
import { apiEsqueceuSenha } from '../../api/auth/apiEsqueceuSenha';

export default function Login() {

  const [erroLogin, setErroLogin] = useState(false)
  const [showPassword, setShowPassword] = useState(false);
  const [checkedRememberMe, setCheckedRememberMe] = useState(true);
  const [isLoading, setIsLoading] = useState(false)
  const [controlaBooleano, setControlaBooleano] = useState({ enviouLink: false, emailIvalido: false })
  const navigate = useNavigate();
  const [desabilitado, setDesabilitado] = useState(false);

  const loginRef = useRef(null);
  const passRef = useRef(null);


  useEffect(() => {
    verificarLembre();
  }, []);

  const verificarLembre = async () => {
    const lembre = localStorage.getItem('YD7nYJ0l1Wx3');

    if (!lembre) { return; }

    if (!checkedRememberMe && loginRef.current && passRef.current) {
      localStorage.removeItem('YD7nYJ0l1Wx3');
      return
    }

    const decriptedLogin = await decryptCryptoJs(lembre);

    const res = JSON.parse(decriptedLogin);

    if (loginRef.current) {
      loginRef.current.value = res.login;
      passRef.current.value = res.password;
    }

  }


  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true)

    const data = new FormData(event.currentTarget);

    const payload = { login: data.get('login'), password: data.get('password') }

    const { status } = await apiLogin(payload);

    if (status !== 200) {
      localStorage.removeItem('YD7nYJ0l1Wx3');
      setErroLogin(true);
      setIsLoading(false)
      return;
    }

    setErroLogin(false)

    //se não está marcado ele remove
    if (!checkedRememberMe) {
      localStorage.removeItem('YD7nYJ0l1Wx3');
      setIsLoading(false)
    } else {
      //se está marcado ele guarda no storage 
      const stringLogin = JSON.stringify(payload);
      const encryptLogin = await encryptCryptoJs(stringLogin)
      localStorage.setItem('YD7nYJ0l1Wx3', encryptLogin);
      setIsLoading(false)
    }

    navigate('/private/agenda/locais')

  };

  const verificaCampoUser = () => {
    const userLogin = loginRef.current?.value; // Obtém o valor do input
    if (userLogin) {
      apiEsqueceuSenha(userLogin, { setControlaBooleano, setErroLogin });
      setDesabilitado(true);
    } else {
      setErroLogin(true); // Exibe erro se o campo estiver vazio
    }
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => event.preventDefault();

  const handleMouseUpPassword = (event) => event.preventDefault();

  const handleChange = (event) => setCheckedRememberMe(event.target.checked);

  return (

    <ThemeProvider theme={theme}>
      <Box sx={{ backgroundColor: '#141259', minHeight: "100vh", display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Paper elevation={4} sx={{ borderRadius: '20px', background: '#fff' }}>
            <Box sx={{ marginTop: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '0 40px 20px 40px' }}>
              <HeaderLogin />
              <Box component="form" onSubmit={handleSubmit}>

                <TextField margin="normal" id="login" label="E-mail" name="login" variant="standard" autoComplete="login" type='email'
                  required fullWidth autoFocus error={erroLogin} InputLabelProps={{ required: false }} inputRef={loginRef} />

                {controlaBooleano.emailIvalido && (
                  <Typography color="red" >E-mail inválido</Typography>
                )}

                <FormControl sx={{ width: '100%' }} variant="standard">
                  <InputLabel htmlFor="password">Senha</InputLabel>
                  <Input id="password" type={showPassword ? 'text' : 'password'} name="password" inputRef={passRef} required
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} onMouseUp={handleMouseUpPassword}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>

                <Typography color='red'>{erroLogin ? 'Dados Incorretos' : ''}</Typography>

                <Grid
                  component="div" // Alterado para div para evitar comportamento de link
                  onClick={() => {
                    if (!desabilitado) {
                      verificaCampoUser();
                    }
                  }}
                  sx={{
                    cursor: desabilitado ? 'not-allowed' : 'pointer', fontWeight: 'normal', fontSize: 16, textDecoration: 'underline', alignItems: 'center', mt: { xs: 1, md: 0 }, textAlign: 'center',
                    padding: 1,
                    color: desabilitado ? 'gray' : 'inherit',
                    "&:hover": { color: desabilitado ? 'gray' : "#141259" }
                  }}
                >
                  Redefinir senha
                </Grid>

                {(controlaBooleano.enviouLink && !controlaBooleano.emailIvalido) && (
                  <Typography color="#1b1464" textAlign={'center'}>E-mail enviado!</Typography>
                )}

                <Checkbox
                  sx={{ '& .MuiSvgIcon-root': { fontSize: 22 }, marginLeft: -1 }} checked={checkedRememberMe} id='checkRemember'
                  onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} />
                <label htmlFor="checkRemember" sx={{ userSelection: 'none' }}>Permanecer conectado</label>

                <Button type="submit" fullWidth variant="contained" sx={{ mt: 2, mb: 2, bgcolor: 'primary.main' }} disabled={isLoading}>
                  Entrar
                </Button>
              </Box>
            </Box>
          </Paper>
          <Copyright sx={{ mt: 3, mb: 3 }} />
        </Container>
      </Box>
    </ThemeProvider>

  );
}